import React, { useEffect, useState } from 'react';
import { ChevronRight16 } from '@carbon/icons-react';
import { SkeletonText, TooltipIcon } from 'carbon-components-react';
import { numberToshortString } from 'utilities/formatters';
import { InformationFilled16 } from '@carbon/icons-react';

const InfoTile: React.FC<Props> = ({
  isLoading,
  title,
  value,
  invert,
  linkAction,
  linkLabel,
  tooltipText,
  hideValue,
  className
}) => {
  const [text, setText] = useState<string | React.ReactElement>('');
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    typeof value === 'number' && setText(numberToshortString(value));
    typeof value !== 'number' && setText(value);
  }, [value]);

  return (
    <div
      className={`dashboard-component--info${invert ? ' is-invert' : ''}${
        linkAction ? ' is-clickable' : ''
      }${className ? ` ${className}` : ''}`}
      onClick={() => linkAction && linkAction()}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="component-title">
        {title}
        {isHover && tooltipText ? (
          <TooltipIcon
            tooltipText={tooltipText || ''}
            className="dashboard-tooltip-info"
          >
            <InformationFilled16 className="dashboard-tooltip-info-icon" />
          </TooltipIcon>
        ) : null}
      </div>
      <div className="info-footer-container">
        {isLoading ? (
          <SkeletonText />
        ) : (
          <>
            {!hideValue && <div className="component-value">{text}</div>}
            <div className="component-link">
              {linkLabel && <label>{linkLabel}</label>}
              {linkAction && <ChevronRight16 />}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

type Props = {
  isLoading: boolean;
  title: string;
  value: number | string | React.ReactElement;
  invert?: boolean;
  linkAction?: Function;
  linkLabel?: string;
  tooltipText?: string;
  hideValue?: boolean;
  className?: string;
};

export default React.memo(InfoTile);
